import { axisStateMap } from './axisStateMap'
import { bajajStateMap } from './bajajStateMap'
import { hdfcCardStateMap } from './hdfcCardStateMap'
import { hdfcStateMap } from './hdfcStateMap'
import { hlStateMap } from './hlStateMap'
import { lntStateMap } from './lntStateMap'
import { plStateMap } from './plStateMap'
import { scbStateMap } from './scbStateMap'

export const stateMap = {
  239: axisStateMap,
  197: scbStateMap,
  261: hdfcStateMap,
  219: bajajStateMap,
  289: lntStateMap,
  299: hdfcCardStateMap,
  403: plStateMap,
  404: plStateMap,
  405: plStateMap,
  406: plStateMap,
  407: plStateMap,
  408: plStateMap,
  409: plStateMap,
  410: plStateMap,
  411: plStateMap,
  412: plStateMap,
  413: plStateMap,
  420: plStateMap,
  644: plStateMap,
  656: hlStateMap,
  418: hlStateMap,
  430: plStateMap,
}
